import React from 'react'
import styles from './styles.module.css'

import MobileNav from './components/MobileNav'
import MainNav from './components/MainNav'

export { MobileNav, MainNav }
export const CredibbleHeader = (props) => {
  return (
    <div className={styles.test}>
      <MainNav />
      <MobileNav />
    </div>
  )
}

// <Header>
// <Blog>
// <Footer>

// <Header>
// <MainContent>
// <Footer>

// Header
// - MobileNav -- show hide using css
//   - Hamburger -- onSlide={function}
//   - MobileSidebar -- onSlide={function}
//   - MobileMenu
// - DekstopNav -- show hide using css
//   - DesktopMenu

// on Layout
//  ...
//
// function handleSlide(){
//   setSlide(true)
// }
//
// return (<>
//   <Header onSlide={handleSlide}>
// </>)

// on Blog
//  ...
//
// function handleSlide(){
//   document.querySelector('.credibble-blog').classList.contains('slided')
// }
//
// return (<>
//   <Header onSlide={handleSlide}>
// </>)
